module.exports = __webpack_public_path__ + "img/home-1-570x703.6de94545.jpg";